import { render, staticRenderFns } from "./QuesLibDetail.vue?vue&type=template&id=0477b8bd"
import script from "./QuesLibDetail.vue?vue&type=script&lang=js"
export * from "./QuesLibDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports